import { render, staticRenderFns } from "./Layout1.vue?vue&type=template&id=066589b8&"
import script from "./Layout1.vue?vue&type=script&lang=js&"
export * from "./Layout1.vue?vue&type=script&lang=js&"
import style0 from "./Layout1.vue?vue&type=style&index=0&id=066589b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports